__turbopack_context__.v({
  "footer": "oVCVfq_footer",
  "next-button-pulse": "oVCVfq_next-button-pulse",
  "nextButtonPulse": "oVCVfq_nextButtonPulse",
});
